@if (loading$ | async) {
  <gbc-loading-spinner class="spinner"></gbc-loading-spinner>
}
@if (!(loading$ | async)) {
  <ng-content></ng-content>
}
